/* 
Author:Lamiaa Moustafa
Desc: Login page UI
*/

import React, { useState } from "react";
import { ButtonDiv } from "../../Styles/styledComponents/Divs";
import { Slogan } from "../../components/text/Slogan";
import { FormInput } from "../../components/inputs/FormInput";
import { Button1st2911 } from "../../components/buttons/Button1st2911";
import { TransDiv } from "../../Styles/styledComponents/Divs";
import { Link } from "react-router-dom";
import { Form } from "../../Styles/styledComponents/Inputs";
// import { getAuth, signInWithEmailAndPassword } from "firebase/auth";
//import { AuthContextProvider } from "../../contexts/AuthContext";
//  import {CA_auth,C3VLAR_auth} from "../../firebaseConfig"
//  import { signInWithCustomToken } from "firebase/auth";

const Login = () => {
  const [formValue, setFormValue] = useState({
    email: "",
    password: "",
  });
  const [formErrors, setFormErrors] = useState({});
  const handleClickLogin = async (e) => {
    e.preventDefault(); // prevent page refresh

    //Validating form input values
    setFormErrors(validate(formValue));
  };

  /*
    Author: Reshma Ghanta
    Desc:  validating for form inputs from user using Regex
*/
  const validate = (values) => {
    const errors = {};
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i;

    if (!values.email) {
      errors.email = "Email is required!";
    } else if (!regex.test(values.email)) {
      errors.email = "This is not a valid email format!";
    }
    if (!values.password) {
      errors.password = "Password is required!";
    } else if (values.password.length < 6) {
      errors.password = "Password must be atleast 6 characters";
    } else if (values.password.length > 10) {
      errors.password = "Password cannot exceed more than 10 characters";
    }
    return errors;
  };

  return (
    <>
      <TransDiv>
        <Slogan data={{ label: "connected &" }} />
        <Slogan data={{ label: "Protected" }} />
        <Form>
          <FormInput
            data={{
              name: "email",
              type: "email",
              placeholder: "EMAIL",
              width: "50%",
              error: formErrors.email,
            }}
          />
          <FormInput
            data={{
              name: "password",
              type: "password",
              placeholder: "PASSWORD",
              width: "50%",
              error: formErrors.password,
            }}
          />
          <ButtonDiv>
            <Link className="linkStyle" to="/forgotpassword">
              Forgot Password?
            </Link>
            <Button1st2911
              data={{ label: "LOGIN", onClick: handleClickLogin }}
            />
          </ButtonDiv>
        </Form>
      </TransDiv>
    </>
  );
};

export default Login;
